export default "__VITE_ASSET__BlbB3Z0___"